import { useTranslation } from "react-i18next";
import { NavLink } from "./NavLink";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

interface DesktopMenuProps {
  isActive: (path: string) => boolean;
}

export const DesktopMenu = ({ isActive }: DesktopMenuProps) => {
  const { t } = useTranslation(["menu"]);
  const [isOpen, setIsOpen] = useState(false);

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <div className="hidden md:flex items-center space-x-8">
      <NavLink to="/drh" isActive={isActive("/drh")}>
        {t('hr')}
      </NavLink>
      <NavLink to="/recruteurs" isActive={isActive("/recruteurs")}>
        {t('recruiters')}
      </NavLink>
      <NavLink to="/particuliers" isActive={isActive("/particuliers")}>
        {t('individuals')}
      </NavLink>
      <NavLink to="/formations" isActive={isActive("/formations")}>
        {t('training')}
      </NavLink>

      <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenuTrigger className="flex items-center gap-1 text-neutral-600 hover:text-brand-orange transition-colors py-1">
          {t('tools')}
          <ChevronDown className="h-4 w-4" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-[200px] bg-background">
          <div className="px-2 py-1.5 space-y-0.5">
            <DropdownMenuItem onClick={() => setIsOpen(false)} className="rounded-md">
              <NavLink to="/search-engine" isActive={isActive("/search-engine")} className="w-full px-2 py-1.5">
                {t('searchEngine')}
              </NavLink>
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setIsOpen(false)} className="rounded-md">
              <NavLink to="/meta-referentiel" isActive={isActive("/meta-referentiel")} className="w-full px-2 py-1.5">
                {t('metaReferential')}
              </NavLink>
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setIsOpen(false)} className="rounded-md">
              <NavLink to="/rncp-presentation" isActive={isActive("/rncp-presentation")} className="w-full px-2 py-1.5">
                {t('rncp')}
              </NavLink>
            </DropdownMenuItem>
          </div>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
